<template>
    <el-container>
      <el-aside width="200px">
        <SideMenu></SideMenu>
      </el-aside>
      <el-container>
        <el-header style="height: 55px;">
          <Strong>后台管理系统</Strong>
          <div class="header-avatar block">
            <el-avatar class="el-avatar" size="medium" :src="userInfo.avatar"></el-avatar>
            <el-dropdown>
                      <span class="el-dropdown-link">
                        {{userInfo.username}}<i class="el-icon-arrow-down el-icon--right"></i>
                      </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item :underline="false">
                  <router-link :to="{name: 'UserCenter'}">个人中心</router-link>
                </el-dropdown-item>
                <el-dropdown-item @click.native="logout">退出</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </el-header>
        <el-main>
          <div style="margin: 0 15px;">
            <router-view></router-view>
          </div>
        </el-main>
      </el-container>
    </el-container>
</template>


<script>
import SideMenu from "@/views/siderbar/SideMenu";
// import Tabs from "./inc/Tabs";
import axios from "@/axios";

export default {
  name: "Home",
  components: {
     SideMenu
  },
  data() {
    return {
      userInfo: {
        userId: "",
        username: "",
        avatar: ""
      }
    }
  },
  created() {
    this.getUserInfo()
  },
  methods: {
    getUserInfo() {

      axios.get("/sys/user/info").then(res => {
        this.userInfo.userId = res.data.data.userId
        this.userInfo.username = res.data.data.username
        console.log(this.userInfo)
      })
    },
    logout() {
      axios.post("/sys/logout").then(res => {
        localStorage.clear()
        sessionStorage.clear()
        this.$store.commit("resetState")
        this.$router.push("/login")
      })
    }
  }
}
</script>


<style scoped>
.el-container {
  padding: 0;
  margin: 0;
  height: 100%;
}

.header-avatar {
  float: right;
  width: 110px;
  display: flex;
  justify-content: space-around;
  align-items: center;
}

.el-dropdown-link {
  cursor: pointer;
}

.el-header {
  background-color: #17B3A3;
  color: #333;
  text-align: center;
  line-height: 60px;
}

.el-aside {
  background-color: #D3DCE6;
  color: #333;
  line-height: 100%;
}

.el-main {
  color: #333;
  padding: 0;
}

a {
  text-decoration: none;
}
</style>
